module.exports = __webpack_public_path__ + "static/media/addPost.9cf9e936.svg";